import { rvSelectedAccountTransaction } from 'graphql/reactiveVariables'
import { DebitCardTransactionUpdate_onDebitCardTransactionUpdate as DebitCardTransactionUpdate } from 'types/gql-types/DebitCardTransactionUpdate'
import {
  GetDebitCardTransactions_getDebitCardTransactionsV2_transactions as DebitCardTransaction,
  GetDebitCardTransactionsVariables,
} from 'types/gql-types/GetDebitCardTransactions'
import { useUpdateDebitCardTransaction } from 'pages/DebitCardTransactions/hooks/useUpdateDebitCardTransaction/useUpdateDebitCardTransaction'
import {
  getIsADebitCardTransaction,
  padWithNulls,
} from 'pages/DebitCardTransactions/hooks/useUpdateDebitCardTransaction/useUpdateDebitCardTransaction.utils'

interface UseUpdateSelectedAccountTransactionProps {
  variables: GetDebitCardTransactionsVariables
}

export const useUpdateSelectedAccountTransaction = ({
  variables,
}: UseUpdateSelectedAccountTransactionProps) => {
  const { updateTransaction } = useUpdateDebitCardTransaction({ variables })

  const handleUpdate = (
    updatedData:
      | Partial<DebitCardTransaction>
      | Partial<DebitCardTransactionUpdate>
  ) => {
    const selectedTransaction = rvSelectedAccountTransaction()

    if (selectedTransaction) {
      const handleUpdateWithQueriedTransaction = (
        partialTransaction: Partial<DebitCardTransaction>
      ) => {
        const updatedTransaction = {
          ...selectedTransaction,
          ...partialTransaction,
        }

        updateTransaction(updatedTransaction)
        rvSelectedAccountTransaction(updatedTransaction)
      }

      const handleUpdateWithSubscriptionData = (
        partialTransactionUpdate: Partial<DebitCardTransactionUpdate>
      ) => {
        const newContact = partialTransactionUpdate.contact
          ? {
              ...partialTransactionUpdate.contact,
              category: null,
            }
          : null

        const contact = selectedTransaction.contact
          ? {
              ...selectedTransaction.contact,
              ...partialTransactionUpdate.contact,
            }
          : newContact

        if (selectedTransaction.merchant) {
          const updatedTransactionWithMerchant = {
            ...selectedTransaction,
            ...partialTransactionUpdate,
            merchant: {
              ...selectedTransaction.merchant,
              ...partialTransactionUpdate.merchant,
            },
            contact,
          }

          updateTransaction(updatedTransactionWithMerchant)
          rvSelectedAccountTransaction(updatedTransactionWithMerchant)
          return
        }

        const updatedMerchant = partialTransactionUpdate.merchant
          ? padWithNulls(partialTransactionUpdate.merchant)
          : null

        const updatedTransaction = {
          ...selectedTransaction,
          ...partialTransactionUpdate,
          merchant: updatedMerchant,
          contact,
        }

        updateTransaction(updatedTransaction)
        rvSelectedAccountTransaction(updatedTransaction)
      }

      if (getIsADebitCardTransaction(updatedData)) {
        handleUpdateWithQueriedTransaction(updatedData)
        return
      }

      handleUpdateWithSubscriptionData(updatedData)
    }
  }

  return { handleUpdate }
}
